module.exports = __webpack_public_path__ + "img/download.62a94be3.svg";